module.exports = __webpack_public_path__ + "img/speed.f841a41c.svg";